/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  ClassEligibilityTypeEnum,
  ClassEligibilityTypeEnumOptional,
  ClassEligibilityTypeEnumMetaI,
  ClassEligibilityTypeEnumTrackedI,
} from "./class-eligibility-type-enum";
import {
  ClassEligibilityTypeEnumTracked,
  ClassEligibilityTypeEnumMeta,
} from "./class-eligibility-type-enum";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonRef,
  PersonRefOptional,
  PersonRefMetaI,
  PersonRefTrackedI,
} from "./person-ref";
import { PersonRefTracked, PersonRefMeta } from "./person-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassTypeRef,
  UnifiedClassTypeRefOptional,
  UnifiedClassTypeRefMetaI,
  UnifiedClassTypeRefTrackedI,
} from "./unified-class-type-ref";
import {
  UnifiedClassTypeRefTracked,
  UnifiedClassTypeRefMeta,
} from "./unified-class-type-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  WithPersonRef,
  WithPersonRefOptional,
  WithPersonRefMetaI,
  WithPersonRefTrackedI,
} from "./with-person-ref";
import { WithPersonRefTracked, WithPersonRefMeta } from "./with-person-ref";

/**
 *
 * @export
 * @interface UnifiedClassTypeOverrideBase
 */
export interface UnifiedClassTypeOverrideBaseOptional extends WithPersonRefOptional {
  /**
   *
   * @type {PersonRef}
   * @memberof UnifiedClassTypeOverrideBase
   */
  personId?: PersonRefOptional;
  /**
   *
   * @type {UnifiedClassTypeRef}
   * @memberof UnifiedClassTypeOverrideBase
   */
  typeId?: UnifiedClassTypeRefOptional;
  /**
   *
   * @type {number}
   * @memberof UnifiedClassTypeOverrideBase
   */
  season?: number;
  /**
   *
   * @type {ClassEligibilityTypeEnum}
   * @memberof UnifiedClassTypeOverrideBase
   */
  overrideType?: ClassEligibilityTypeEnum;
}

export interface UnifiedClassTypeOverrideBase
  extends UnifiedClassTypeOverrideBaseOptional, WithPersonRef {
  /**
   *
   * @type {PersonRef}
   * @memberof UnifiedClassTypeOverrideBase
   */
  personId: PersonRef;
  /**
   *
   * @type {UnifiedClassTypeRef}
   * @memberof UnifiedClassTypeOverrideBase
   */
  typeId?: UnifiedClassTypeRef;
  /**
   *
   * @type {number}
   * @memberof UnifiedClassTypeOverrideBase
   */
  season?: number;
  /**
   *
   * @type {ClassEligibilityTypeEnum}
   * @memberof UnifiedClassTypeOverrideBase
   */
  overrideType?: ClassEligibilityTypeEnum;
}

export interface UnifiedClassTypeOverrideBaseTrackedI extends WithPersonRefOptional {
  /**
   *
   * @type {PersonRef}
   * @memberof UnifiedClassTypeOverrideBase
   */
  personId?: PersonRefTrackedI;
  personIdIsSet: boolean;
  /**
   *
   * @type {UnifiedClassTypeRef}
   * @memberof UnifiedClassTypeOverrideBase
   */
  typeId?: UnifiedClassTypeRefTrackedI;
  typeIdIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof UnifiedClassTypeOverrideBase
   */
  season?: number;
  seasonIsSet: boolean;
  /**
   *
   * @type {ClassEligibilityTypeEnum}
   * @memberof UnifiedClassTypeOverrideBase
   */
  overrideType?: ClassEligibilityTypeEnum;
  overrideTypeIsSet: boolean;
}

transformDatesMap.set(
  "UnifiedClassTypeOverrideBase",
  function (model: UnifiedClassTypeOverrideBase) {
    const transformDatespersonId = transformDatesMap.get("PersonRef");
    if (transformDatespersonId && model.personId) {
      transformDatespersonId(model.personId);
    }
    const transformDatestypeId = transformDatesMap.get("UnifiedClassTypeRef");
    if (transformDatestypeId && model.typeId) {
      transformDatestypeId(model.typeId);
    }
  },
);

export type UnifiedClassTypeOverrideBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  personId: PropertyMeta<PersonRefMetaI>;
  //isDate: false
  //isDatetime: false
  typeId: PropertyMeta<UnifiedClassTypeRefMetaI>;
  //isDate: false
  //isDatetime: false
  season: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  overrideType: PropertyMeta<ClassEligibilityTypeEnumMetaI>;
}>;

export var UnifiedClassTypeOverrideBaseMeta: UnifiedClassTypeOverrideBaseMetaI =
  {} as UnifiedClassTypeOverrideBaseMetaI;
UnifiedClassTypeOverrideBaseMeta = typeMeta("UnifiedClassTypeOverrideBase", {
  personId: propertyMeta("personId", false, true, false, PersonRefMeta),
  typeId: propertyMeta("typeId", false, false, false, UnifiedClassTypeRefMeta),
  season: propertyMeta("season", false, false, false, MetaTypesBase.number),
  overrideType: propertyMeta(
    "overrideType",
    false,
    false,
    false,
    ClassEligibilityTypeEnumMeta,
  ),
});

const metaI = UnifiedClassTypeOverrideBaseMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([WithPersonRefMeta]);
  metaI.personId.inheritedFrom = WithPersonRefMeta.personId;
});

export class UnifiedClassTypeOverrideBaseTracked
  extends WithPersonRefTracked
  implements UnifiedClassTypeOverrideBaseTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  personId__I?: PersonRefTracked = undefined;
  personIdIsSet: boolean = false;
  set personId(v: undefined | PersonRefTracked) {
    if (v !== undefined) {
      this.personId__I = v;
      this.personIdIsSet = true;
    } else {
      this.personId__I = v || undefined;
      this.personIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get personId() {
    return this.personId__I;
  }
  typeId__I?: UnifiedClassTypeRefTracked = undefined;
  typeIdIsSet: boolean = false;
  set typeId(v: undefined | UnifiedClassTypeRefTracked) {
    if (v !== undefined) {
      this.typeId__I = v;
      this.typeIdIsSet = true;
    } else {
      this.typeId__I = v || undefined;
      this.typeIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get typeId() {
    return this.typeId__I;
  }
  season__I?: number = undefined;
  seasonIsSet: boolean = false;
  set season(v: undefined | number) {
    if (v !== undefined) {
      this.season__I = v;
      this.seasonIsSet = true;
    } else {
      this.season__I = v || undefined;
      this.seasonIsSet = false;
    }
    this.changeTracker = true;
  }
  get season() {
    return this.season__I;
  }
  overrideType__I?: ClassEligibilityTypeEnum = undefined;
  overrideTypeIsSet: boolean = false;
  set overrideType(v: undefined | ClassEligibilityTypeEnum) {
    if (v !== undefined) {
      this.overrideType__I = v;
      this.overrideTypeIsSet = true;
    } else {
      this.overrideType__I = v || undefined;
      this.overrideTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get overrideType() {
    return this.overrideType__I;
  }
  constructor(
    config?: UnifiedClassTypeOverrideBaseOptional,
    options?: AssignOptions,
  ) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.personId?.setIds();

    this.typeId?.setIds();
  }
  assignFrom(
    config: UnifiedClassTypeOverrideBaseOptional,
    options?: AssignOptions,
  ): UnifiedClassTypeOverrideBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.personId && this.personIdApplyFilter(optionsRequired.filter)) {
      this.personId = new PersonRefTracked(config.personId, options);
      if (optionsRequired.unassign) this.personIdIsSet = false;
      else this.personIdIsSet = true;
    }
    if (config.typeId && this.typeIdApplyFilter(optionsRequired.filter)) {
      this.typeId = new UnifiedClassTypeRefTracked(config.typeId, options);
      if (optionsRequired.unassign) this.typeIdIsSet = false;
      else this.typeIdIsSet = true;
    }
    if (config.season && this.seasonApplyFilter(optionsRequired.filter)) {
      this.season = config.season;
      if (optionsRequired.unassign) this.seasonIsSet = false;
      else this.seasonIsSet = true;
    }
    if (
      config.overrideType &&
      this.overrideTypeApplyFilter(optionsRequired.filter)
    ) {
      this.overrideType = config.overrideType;
      if (optionsRequired.unassign) this.overrideTypeIsSet = false;
      else this.overrideTypeIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): UnifiedClassTypeOverrideBaseTrackedI {
    const cloned = {} as UnifiedClassTypeOverrideBaseTrackedI;
    if (
      this.personIdIsSetDeep() &&
      this.personIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.personIdIsSet = true;
      cloned.personId = this.personId?.removeUnset(filter);
    } else {
      //cloned.personIdIsSet = false
    }
    if (
      this.typeIdIsSetDeep() &&
      this.typeIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.typeIdIsSet = true;
      cloned.typeId = this.typeId?.removeUnset(filter);
    } else {
      //cloned.typeIdIsSet = false
    }
    if (
      this.seasonIsSetDeep() &&
      this.seasonApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.seasonIsSet = true;
      cloned.season = this.season;
    } else {
      //cloned.seasonIsSet = false
    }
    if (
      this.overrideTypeIsSetDeep() &&
      this.overrideTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.overrideTypeIsSet = true;
      cloned.overrideType = this.overrideType;
    } else {
      //cloned.overrideTypeIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): UnifiedClassTypeOverrideBaseTrackedI {
    if (!this.personIdApplyFilter(filter)) this.personIdIsSet = false;
    this.personId?.unassignAll(filter);

    if (!this.typeIdApplyFilter(filter)) this.typeIdIsSet = false;
    this.typeId?.unassignAll(filter);

    if (!this.seasonApplyFilter(filter)) this.seasonIsSet = false;

    if (!this.overrideTypeApplyFilter(filter)) this.overrideTypeIsSet = false;

    return this;
  }
  personIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassTypeOverrideBaseMeta.personId,
      UnifiedClassTypeOverrideBaseMeta,
      this.personId,
      this,
    );
  }
  personIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.personIdIsSet && this.personIdApplyFilter(filter)) return true;
    return this.personId?.anySet(filter) == true;

    return false;
  }
  typeIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassTypeOverrideBaseMeta.typeId,
      UnifiedClassTypeOverrideBaseMeta,
      this.typeId,
      this,
    );
  }
  typeIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.typeIdIsSet && this.typeIdApplyFilter(filter)) return true;
    return this.typeId?.anySet(filter) == true;

    return false;
  }
  seasonApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassTypeOverrideBaseMeta.season,
      UnifiedClassTypeOverrideBaseMeta,
      this.season,
      this,
    );
  }
  seasonIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.seasonIsSet && this.seasonApplyFilter(filter)) return true;

    return false;
  }
  overrideTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassTypeOverrideBaseMeta.overrideType,
      UnifiedClassTypeOverrideBaseMeta,
      this.overrideType,
      this,
    );
  }
  overrideTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.overrideTypeIsSet && this.overrideTypeApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.personIdIsSetDeep(filter)) return true;
    if (this.typeIdIsSetDeep(filter)) return true;
    if (this.seasonIsSetDeep(filter)) return true;
    if (this.overrideTypeIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
